<template>
  <NuxtLink
    :to="to"
    class="py-2 text-sm font-normal leading-none text-gray-secondary lg:leading-normal"
    :class="{
      'inline-block': !isPdp,
      'flex flex-row items-center': isPdp,
    }"
  >
    <slot />
  </NuxtLink>
</template>

<script setup lang="ts">
defineProps({
  to: {
    type: [String, Object] as PropType<string | object>,
    required: true,
  },
  isPdp: {
    type: Boolean as PropType<boolean>,
    default: false,
  },
})
</script>
